<template>
  <div>
    <div class="mt-2 flex flex-row items-center" v-if="addressBook.length > 0">
      <div class="flex-1 h-px border-b mr-2"></div>
      <div class="flex-none w-40 text-xs">
        <select class="form-input" v-model="selectedAddress">
          <option value="">-Mis direcciones-</option>
          <option :value="i" :key="`address-${i}`" v-for="(a, i) in addressBook">{{ a.title }}</option>
        </select>
      </div>
    </div>
    <div class="flex flex-col sm:flex-row -mx-2">
      <div class="w-full sm:w-1/3 px-2 sm-2" v-if="showCountries">
        <p class="mb-1"><label :for="countryFieldName" class="form-label">País *</label></p>
        <select :name="countryFieldName" :id="countryFieldName" class="form-input" v-model="countryId">
          <option value="">-Selecciona-</option>
          <option :key="`country-${country.id}`" :value="country.id" v-for="country in countries">{{ country.name }}</option>
        </select>
      </div>
      <div :class="showCountries ? 'sm:w-1/3' : 'sm:w-1/2'" class="w-full px-2 mb-2">
        <p class="mb-1"><label :for="stateFieldName" class="form-label">Estado/Departamento *</label></p>
        <select :name="stateFieldName" :id="stateFieldName" class="form-input" v-model="stateId">
          <option value="">-Selecciona-</option>
          <option :key="`state-${state.id}`" :value="state.id" v-for="state in states">{{ state.name }}</option>
        </select>
      </div>
      <div :class="showCountries ? 'sm:w-1/3' : 'sm:w-1/2'" class="w-full px-2 mb-2">
        <p class="mb-1"><label :for="cityFieldName" class="form-label">Ciudad/Municipio *</label></p>
        <select :name="cityFieldName" :id="cityFieldName" class="form-input" v-model="cityId">
          <option value="">-Selecciona-</option>
          <option :key="`city-${city.id}`" :value="city.id" v-for="city in cities">{{ city.name }}</option>
        </select>
      </div>
    </div>
    <div class="mb-2">
      <p class="mb"><label :for="addressFieldName" class="form-label">Dirección *</label></p>
      <input type="text" class="form-input" :name="addressFieldName" :id="addressFieldName" maxlength="191" v-model="address">
    </div>
    <div class="mb-2" v-if="countryId != 90 && showCountries">
      <p class="mb"><label :for="zipCodeFieldName" class="form-label">Código postal *</label></p>
      <input type="text" class="form-input" :name="zipCodeFieldName" :id="zipCodeFieldName" maxlength="10" v-model="zipCode">
    </div>
  </div>
</template>
<script>
import { globalEventBus } from '../../_globalEventBus';
export default {
  name: 'geographics-selector',
  props: {
    showAddressBook: { type: Boolean, default: false},
    showCountries: { type: Boolean, default: true },
    addressValue: { type: String, default: '' },
    addressFieldName: { type: String, default: 'address' },
    countryValue: { type: String, default: '' },
    countryFieldName: { type: String, default: 'country_id' },
    stateValue: { type: String, default: '' },
    stateFieldName: { type: String, default: 'state_id' },
    cityValue: { type: String, default: '' },
    cityFieldName: { type: String, default: 'city_id' },
    zipCodeValue: { type: String, default: '' },
    zipCodeFieldName: { type: String, default: 'zip_code' },
  },
  data() {
    return {
      address: '',
      countryId: '',
      stateId: '',
      cityId: '',
      zipCode: '',
      countries: [],
      states: [],
      cities: [],
      addressBook: [],
      selectedAddress: '',
    }
  },
  watch: {
    selectedAddress(newVal) {
      
    },
    countryId (newVal) {
      if (newVal != this.countryValue && this.showCountries) {
        this.stateId = '';
        this.cityId = '';
      }

      globalEventBus.$emit(
        'countryUpdated',
        {
          field_name: this.countryFieldName,
          value: newVal
        }
      );

      this.loadStates();
    },
    stateId (newVal) {
      if (newVal != this.stateValue) {
        this.cityId = '';
      }
      this.loadCities();
    }
  },
  mounted() {
    this.address = this.addressValue;
    this.countryId = this.countryValue;
    this.stateId = this.stateValue;
    this.cityId = this.cityValue;
    this.zipCode = this.zipCodeValue;

    if (this.showCountries) {
      this.loadCountries();
    } else {
      this.countryId = 90;
    }

    if (this.showAddressBook) {
      this.loadAddressBook();
    }

    globalEventBus.$on('copyBillingAddress', data => {
      if (this.stateFieldName == 'shipping_state_id') {
        this.address = document.getElementById('billing_address').value;
        this.stateId = document.getElementById('billing_state_id').value;
        setTimeout(() => {
          this.cityId = document.getElementById('billing_city_id').value;
        }, 250);
      }
    });
  },
  methods: {
    loadAddressBook() {
      axios.get('/auth/mis-direcciones')
        .then(response => {
          this.addressBook = response.data.data;
        })
        .catch(error => {
          alert('Lo sentimos, ocurrió algo extraño y no pudimos cargar tu libreta de direcciones. Intenta nuevamente.');
        });
    },
    loadCountries() {
      axios.get('/paises')
        .then(response => {
          this.countries = response.data.data;
        })
        .catch(error => {
          alert('Lo sentimos, ocurrió algo extraño y no pudimos cargar los países. Intenta nuevamente.');
        });
    },
    loadStates() {
      this.states = [];
      axios.get(`/estados?pais=${this.countryId}`)
        .then(response => {
          this.states = response.data.data;
        })
        .catch(error => {
          alert('Lo sentimos, ocurrió algo extraño y no pudimos cargar los estados. Intenta nuevamente.');
        });
    },
    loadCities() {
      this.cities = [];
      axios.get(`/ciudades?estado=${this.stateId}`)
        .then(response => {
          this.cities = response.data.data;
        })
        .catch(error => {
          alert('Lo sentimos, ocurrió algo extraño y no pudimos cargar las ciudades. Intenta nuevamente.');
        });
    }
  }
}
</script>